/* 🤖 this file was generated by svg-to-ts */
export const mgcIconPlayFilled: {
  name: 'play-filled';
  data: string;
} = {
  name: 'play-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.691 3.536c-.551.18-.917.612-1.008 1.19-.057.361-.151 1.321-.222 2.254a71.74 71.74 0 0 0-.039 9.48c.133 1.973.247 2.922.39 3.233.207.453.669.772 1.179.814.359.03.52-.011 1.182-.304 3.574-1.581 7.934-4.074 11.224-6.418.865-.616 1.109-.828 1.251-1.091.287-.53.202-1.248-.199-1.68-.269-.289-2.1-1.57-3.689-2.581-2.67-1.698-5.873-3.436-8.42-4.571-.776-.345-.81-.356-1.14-.369a1.646 1.646 0 0 0-.509.043"/></svg>`
};
